<div class="article-grid news">
  @for (i of [1, 2, 3, 4, 5, 6]; track $index) {
    <ng-container>
      <ds-skeleton type="card-landscape" [showAnimation]="true"> </ds-skeleton>
    </ng-container>
  }
</div>
